
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host(.push-content) .open .dropdown-placeholder {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 1px solid var(--slh-color-primary-shade-60, #89B7E5) !important;
}
:host(.push-content) .open .dropdown-items {
  border: 2px solid var(--slh-color-primary-shade-60, #89B7E5);
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  filter: none;
  position: relative;
  min-width: auto;
}

.dropdown-wrapper, :host .dropdown {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.dropdown-wrapper select, :host .dropdown select {
  display: none;
  width: 0;
  height: 0;
}
.dropdown-wrapper .dropdown-placeholder, :host .dropdown .dropdown-placeholder {
  outline: none;
  border: 2px solid var(--slh-color-neutral-shade-20, #EBEEF4);
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  position: relative;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--slh-base-xs-font-size, 14px);
  border-radius: 8px;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  padding-top: calc(12px - 2px);
  padding-right: 32px;
  padding-bottom: calc(12px - 2px);
  padding-left: 16px;
  cursor: pointer;
  color: var(--slh-color-neutral-shade-60, #62779F);
  align-content: flex-start;
  list-style: none;
  min-height: 24px;
}
.dropdown-wrapper .dropdown-placeholder .icon-wrapper, :host .dropdown .dropdown-placeholder .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
  position: absolute;
  display: inline-flex;
  right: 8px;
}
.dropdown-wrapper.disabled .dropdown-placeholder, :host .disabled.dropdown .dropdown-placeholder, .dropdown-wrapper.readonly .dropdown-placeholder, :host .readonly.dropdown .dropdown-placeholder {
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.dropdown-wrapper .dropdown-items, :host .dropdown .dropdown-items {
  visibility: hidden;
  /* Track */
  /* Handle */
  z-index: 999;
  display: block;
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  padding: 0;
  min-width: 230px;
  margin: 0;
  padding-top: 8px;
  padding-bottom: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  max-height: 400px;
  overflow-y: auto;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
.dropdown-wrapper .dropdown-items::-webkit-scrollbar, :host .dropdown .dropdown-items::-webkit-scrollbar {
  width: 10px;
}
.dropdown-wrapper .dropdown-items::-webkit-scrollbar-track, :host .dropdown .dropdown-items::-webkit-scrollbar-track {
  background: var(--slh-color-neutral-shade-10, #F6F7FA);
}
.dropdown-wrapper .dropdown-items::-webkit-scrollbar-thumb, :host .dropdown .dropdown-items::-webkit-scrollbar-thumb {
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
  border-radius: 10px;
}
.dropdown-wrapper .dropdown-items::-webkit-scrollbar-thumb:hover, :host .dropdown .dropdown-items::-webkit-scrollbar-thumb:hover {
  background: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.dropdown-wrapper.items-right .dropdown-items, :host .items-right.dropdown .dropdown-items {
  left: auto;
  right: 0;
}
.dropdown-wrapper:hover:not(.disabled, .open, .error, .readonly) .dropdown-placeholder, :host .dropdown:hover:not(.disabled, .open, .error, .readonly) .dropdown-placeholder {
  color: var(--slh-color-neutral, #39455D);
  border: 2px solid var(--slh-color-neutral-shade-40, #C0C8D8);
}
.dropdown-wrapper.error .dropdown-placeholder, :host .error.dropdown .dropdown-placeholder {
  color: var(--slh-color-neutral, #39455D);
  border: 2px solid var(--slh-color-error-shade-80, #FFA399);
  background-color: var(--slh-color-error-shade-20, #FFEDEB);
}
.dropdown-wrapper.error:hover .dropdown-placeholder, :host .error.dropdown:hover .dropdown-placeholder {
  border: 2px solid var(--slh-color-error, #FF7E70);
}
.dropdown-wrapper.disabled:hover .dropdown-placeholder, :host .disabled.dropdown:hover .dropdown-placeholder, .dropdown-wrapper.readonly:hover .dropdown-placeholder, :host .readonly.dropdown:hover .dropdown-placeholder {
  cursor: not-allowed;
}
.dropdown-wrapper.open:not(.disabled, .error, .readonly) .dropdown-placeholder, :host .open.dropdown:not(.disabled, .error, .readonly) .dropdown-placeholder {
  color: var(--slh-color-neutral, #39455D);
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  border: 2px solid var(--slh-color-primary-shade-60, #89B7E5);
}
.dropdown-wrapper.open, :host .open.dropdown {
  overflow: visible;
  z-index: 999;
}
.dropdown-wrapper.open .dropdown-items, :host .open.dropdown .dropdown-items {
  display: block !important;
  visibility: visible;
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
}
.dropdown-wrapper.selected .dropdown-placeholder, :host .selected.dropdown .dropdown-placeholder {
  color: var(--slh-color-neutral-shade-60, #62779F);
}

:host {
  outline: none;
  display: inline-block;
  width: 100%;
}
:host .hint-wrapper {
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-bottom: -4px;
}
:host .hint-wrapper .hint-icon-container {
  margin-top: 4px;
  padding-right: 4px;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
}
:host .hint-wrapper * {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-bold-font-weight, 700);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host .hint-wrapper.hidden {
  display: none;
}

:host([disabled]) {
  pointer-events: none;
}

:host([error]) slot[name=label]::slotted(*) {
  color: var(--slh-color-neutral, #39455D);
}

:host-context(.datatable-modal) {
  overflow: visible;
}
:host-context(.datatable-modal) .dropdown-items {
  position: relative;
  border-bottom: 1px solid var(--slh-color-neutral-shade-20, #EBEEF4);
  -webkit-filter: none !important;
  filter: none !important;
  border-radius: 0;
  display: none;
  min-width: auto;
}

:host(:active) :not(.disabled, .error, .readonly) .dropdown-placeholder,
:host(:active) :not(.disabled, .error, .readonly) .dropdown-placeholder,
:host(:focus) :not(.disabled, .error, .readonly) .dropdown-placeholder,
:host(:focus) :not(.disabled, .error, .readonly) .dropdown-placeholder {
  color: var(--slh-color-neutral, #39455D);
  border: 2px solid var(--slh-color-primary-shade-60, #89B7E5);
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host(:active) .error .dropdown-placeholder,
:host(:active) .error .dropdown-placeholder,
:host(:focus) .error .dropdown-placeholder,
:host(:focus) .error .dropdown-placeholder {
  border: 2px solid var(--slh-color-error, #FF7E70);
}
:host(:active) .dropdown:not(.disabled, .error),
:host(:focus) .dropdown:not(.disabled, .error) {
  filter: drop-shadow(0px 2px 2px none);
  -webkit-filter: drop-shadow(0px 2px 2px none);
}
:host(:active) .dropdown.error,
:host(:focus) .dropdown.error {
  filter: drop-shadow(0px 2px 2px none);
  -webkit-filter: drop-shadow(0px 2px 2px none);
}

:host .dropdown .dropdown-placeholder {
  padding-right: 40px;
}

:host([error]) slot[name=label]::slotted(*) {
  color: var(--slh-color-error, #FF7E70);
}

:host(:focus-visible) :not(.disabled, .error) .dropdown-placeholder {
  border: 2px solid var(--slh-color-outline, #4C49D4);
}
`;
